export default{
    SET_FEEDBACK_ITEM : (state, objectItem) => {
        state.feedback[objectItem.itemName] = objectItem.itemData
    },
    PUSH_FEEDBACK_ITEM : (state, objectItem) => {
        state.feedback[objectItem.itemName].push(objectItem.itemData)
    },
    REMOVE_FEEDBACK_ITEM : (state, objectItem) => {
        let index = state.feedback[objectItem.itemName].indexOf(objectItem.itemData)
        state.feedback[objectItem.itemName].splice(index, 1)
    }
}